import {
  Card,
  CardActions,
  Chip,
  GridLegacy as Grid,
  Pagination,
  styled,
  Typography,
  type CSSObject,
  type GridProps,
} from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.04)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.06), 0 0 24px 4px rgba(255, 255, 255, 0.04)',
  maxWidth: '550px',
  marginInline: 'left',
  marginTop: '2rem',
  borderRadius: '20px',
  cursor: 'pointer',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    transform: 'scale(1.015)',
    boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.18), 0 0 40px 8px rgba(255, 255, 255, 0.08)',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    marginInline: 'auto',
  },
}));

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'customColor',
})<{ customColor: string }>(({ customColor }) => ({
  minWidth: '3rem',
  marginRight: '0.3rem',
  color: 'white',
  fontWeight: '600',
  backgroundColor: customColor,

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: customColor,
  },
}));

export const StyledTypographyTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  fontFamily: 'ClashDisplay',
  fontWeight: 900,
  fontSize: '26px',
  letterSpacing: '-0.02em',
  lineHeight: '1.2',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginTop: '0.3rem',

  [theme.breakpoints.down('sm')]: {
    fontSize: '22px',
  },
}));

export const StyledDivDescription = styled('div')(() => ({
  color: 'rgba(255,255,255,0.65)',
  marginTop: '1rem',
  fontSize: '14px',
  lineHeight: '1.6',
}));

export const StyledAuthorName = styled(Typography)(() => ({
  color: '#d6d6d6',
  fontWeight: '500',
  fontSize: '0.85rem',
}));

export const StyledAuthorPosition = styled(Typography)(() => ({
  color: '#bdbdbd',
  fontWeight: '400',
  fontSize: '0.82rem',
}));

export const StyledCardActions = styled(CardActions)(() => ({
  padding: '1rem',
}));

export const StyledGridContainer = styled(Grid)<GridProps>(() => ({
  width: '100%',
  display: 'flex',
  gap: '0.5rem',
}));

export const StyledAuthorGrid = styled(Grid)<GridProps>(() => ({
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'center',
}));

export const StyledPagination = styled(Pagination)(() => ({
  minWidth: '170px',
  '& .MuiPaginationItem-root': {
    color: '#f0f0f0',
    '&:hover': {
      backgroundColor: '#b3d9ff',
    },
  },
  '& .MuiPaginationItem-ellipsis': {
    color: '#f0f0f0',
  },
  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: '#a0c4ff',
    color: '#000',
  },
}));
